var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$route.meta.public)?_c('sidebar'):_vm._e(),_c('v-main',{staticClass:"main-app"},[_c('router-view'),_c('confirm-dialog',{ref:"confirm"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }